import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePostChangePassword } from '../../hooks/react-query/useUserData';
import { LeftArrow, SpinnerIcon } from '../../icons';
import { TextField } from '../../components/ui';
import usePersonStore from '../../store/personStore';

const Menu = ({ handleMenuState, handleLogout, isImpersonated }) => {
  const navigate = useNavigate();

  const { userData } = usePersonStore();

  const [serverError, setServerError] = useState();
  const { mutate, isLoading } = usePostChangePassword();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const handlePasswordReset = (payload) => {
    mutate(payload, {
      onSuccess: (data) => {
        if (data && data.data.status === 'fail') {
          setServerError(data.exceptions[0]);
        } else if (data && data.data.status === 'success') {
          setPasswordScreen(false);
          window.location.href = '/';
        }
      },
    });
  };
  const [showPasswordScreen, setPasswordScreen] = useState(false);
  const windowWidth = window.screen.width;

  const handleFocusOut = () => {
    if (confirmPassword && password !== confirmPassword) {
      setConfirmPasswordError(
        'Οι κωδικοί πρέπει να είναι ίδιοι και να αποτελούνται από 6 χαρακτήρες ή περισσότερους'
      );
    }
  };

  if (showPasswordScreen && windowWidth <= 991) {
    return (
      <div className="lg:hidden container-sm bg-white lg:max-h-[95vh] h-full overflow-y-auto flex flex-col px-5 gap-5">
        {!isImpersonated && <div className="flex gap-3 border-b border-b-fadedgrey py-2">
          <button
            type="button"
            className=""
            onClick={() => setPasswordScreen(false)}
          >
            <LeftArrow />
          </button>
          <h2>Αλλαγή Κωδικού</h2>
        </div>}
        <div className="flex justify-center">
          <form
            onSubmit={(event) => {
              event.preventDefault();
              handlePasswordReset({ password, confirmPassword });
            }}
            className="flex flex-col items-center justify-center gap-8 bg-white rounded-[20px]"
          >
            <div className="flex flex-col gap-4 items-center">
              <TextField
                value={password}
                onChange={(e) => {
                  confirmPasswordError && setConfirmPasswordError('');
                  serverError && setServerError('');
                  setPassword(e.target.value.trim());
                }}
                className={
                  'p-2 border border-[#A5A5A5] rounded-[8px] w-72 text-black'
                }
                label={'KΚωδικός'}
                placeholder={'Συμπλήρωσε τον κωδικό σου'}
                type={'password'}
                id="password"
              />
              <TextField
                value={confirmPassword}
                onChange={(e) => {
                  confirmPasswordError && setConfirmPasswordError('');
                  serverError && setServerError('');
                  setConfirmPassword(e.target.value.trim());
                }}
                className={
                  'p-2 border border-[#A5A5A5] rounded-[8px] w-72 text-black'
                }
                label={'Νέος Κωδικός'}
                placeholder={'Συμπλήρωσε τον νέο κωδικό'}
                type={'password'}
                id="confirmPassword"
                onBlur={handleFocusOut}
              />
              {(serverError || confirmPasswordError) && (
                <p className="text-primary">
                  {confirmPasswordError || serverError}
                </p>
              )}
              <button
                type="submit"
                disabled={
                  !password ||
                  !confirmPassword ||
                  confirmPasswordError ||
                  serverError
                }
                className="btn-primary text-primary-button w-full flex items-center justify-center gap-2"
              >
                {isLoading && <SpinnerIcon />} Υποβολή
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="flex lg:flex-row-reverse items-start bg-white h-[200px] p-6 w-full">
      <div className="flex flex-col gap-4">
        <div className="text-disclaimer text-grenite">{!userData.companyGroupMemberCompany ? userData.name ?? userData.email : userData.companyGroupMemberCompany}</div>
        <div className="flex flex-col items-start gap-3">
          {!isImpersonated && <button
            type="button"
            onClick={() => {
              if (windowWidth <= 991) {
                setPasswordScreen(true);
              } else {
                handleMenuState();
                navigate('/portal/account');
              }
            }}
          >
            <span className="lg:text-label max-lg:h4 max-lg:font-[700]">Αλλαγή Κωδικού</span>
          </button>}
          <button type="button" onClick={handleLogout}>
            <p className="lg:text-label text-primary cursor-pointer max-lg:h4 max-lg:font-[700]">
            Αποσύνδεση
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Menu;
